import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import type React from 'react';
import { StandardTable } from '../../common/UI/StandardTable';
import type { Invoice } from './useBillingData';

interface PastInvoicesProps {
  invoices: Invoice[];
  loadingData: boolean;
  onSelectInvoice: (invoice: Invoice) => void;
}

export const PastInvoices: React.FC<PastInvoicesProps> = ({
  invoices,
  loadingData,
  onSelectInvoice,
}) => {
  return (
    <Paper sx={{ p: 3, height: '100%', maxHeight: 400, display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h6" gutterBottom>
        Past Invoices
      </Typography>
      {loadingData ? (
        <CircularProgress size={24} />
      ) : (
        <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
          <StandardTable
            columns={[
              {
                id: 'period_end',
                label: <strong>Period Ending</strong>,
              },
              {
                id: 'status',
                label: <strong>Status</strong>,
                render: (inv) => (
                  <Box
                    component="span"
                    sx={{
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: '0.75rem',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      backgroundColor: inv.status === 'paid' ? 'success.light' : 'warning.light',
                      color:
                        inv.status === 'paid' ? 'success.contrastText' : 'warning.contrastText',
                    }}
                  >
                    {inv.status}
                  </Box>
                ),
              },
              {
                id: 'total_amount',
                label: <strong>Total Amount</strong>,
                align: 'right',
                render: (inv) => (
                  <>
                    $
                    {inv.total_amount?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{' '}
                    {inv.currency}
                  </>
                ),
              },
            ]}
            data={invoices}
            keyExtractor={(inv) => inv.id}
            emptyStateMessage="No past invoices found."
            size="small"
            stickyHeader
            onRowClick={onSelectInvoice}
          />
        </Box>
      )}
    </Paper>
  );
};
